import ShareMsgBase from './A_G.ShareMsgBase';

class MsgLivesRequest extends ShareMsgBase {
  /**
   * The message that gets sent when you want to ask for lives
   * @param {string} user1AvatarURL
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1AvatarURL, onAllImagesReadyCallback = null) {
    super(3, onAllImagesReadyCallback);

    this.avatar1 = this._addExtImage(379, 127, user1AvatarURL, 0, 139, null);
    this.bg = this._addExtImage(0, 0, 'img/Msg_Life_Request.png', 0, null, null);

    this.title = this.add(new G.Text(336, 43, 'A friend needs you!', {
      style: 'msg-white',
      fontSize: '50px',
    }, 0.5, 420));

    this._objectLoadComplete();
  }
}

G.MsgLivesRequest = MsgLivesRequest;
